import * as React from 'react';

const InputFeedback = ({ error } : any) =>
  error ? (
    <div className="input-feedback">
        <span className="la la-asterisk" />
        {
            error.map((itm: string, idx: number) => (
                <span key={idx}>{ itm }</span>
            ))
        }
    </div>
  ) : null;

export { InputFeedback };
